export default {
        srcSet: __webpack_public_path__ + "static/media/zigzag-top.e5bdd278.png"+" 1839w",
        images: [{path: __webpack_public_path__ + "static/media/zigzag-top.e5bdd278.png",width: 1839,height: 57}],
        src: __webpack_public_path__ + "static/media/zigzag-top.e5bdd278.png",
        toString: function(){return __webpack_public_path__ + "static/media/zigzag-top.e5bdd278.png"},
        placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAABCAMAAACbgxyhAAAABlBMVEVVkpNWk5VPL/ahAAAAAnRSTlNZTGKAJp4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAASSURBVHicY2BkYIAiRhgDqwgAAXIAEXriSYwAAAAASUVORK5CYII=",
        width: 1839,
        height: 57
      }